// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3_hvB","header":"PatientQuestionnaire_header__1BTj6","info":"PatientQuestionnaire_info__3TcLf"};